﻿/*
 * @class rlQuiz
 * @memberOf jQuery.fn
 */

(function ($) {
  $.fn.rlQuiz = function () {

    //hide all questions and answers on initial load
    $('.q-wrapper, .q-answer, .q-answer .correct, .q-answer .wrong, .q-prev, .q-next, .q-results, .q-restart').hide();

    //add target=blank to links within summaries
    $('.q-intro a, .q-answer a, .q-results a').attr('target', '_blank');

    //show first question
    $('.q-wrapper[data-question="1"]').show().addClass('current');

    var currentquestion = $('.q-wrapper.current').data('question'),
        currentradio = $('.q-wrapper.current[data-question="' + currentquestion + '"] input:radio'),
        userscorecounter = ['Quiz Answers:'],
        totalqnumber = $('.q-wrapper').length,
        percentperqnumber = 100 / totalqnumber,
        answerdatacheck = 0,
        numberanswered = 0,
        currentpercentage = 0,
        progressbarstate = 0,
        finalscore = 0;

    //show current question number in progress bar text
    $('.q-number .currentq').html(currentquestion);

    //add in total number of questions
    $('.q-number .total, .q-results .total').html(totalqnumber);

    //currentradio.change(function () {
    $('.q-wrapper input:radio').change(function () {

      //show answer container
      $('.q-wrapper.current').next('.q-answer').show();

      if ($(this).data('check') == 1) {
        //CORRECT
        $('.q-answer[data-answer=' + currentquestion + ']').children('.correct').show();
        $('.q-answer[data-answer=' + currentquestion + ']').children('.wrong').hide();
      } else {
        //WRONG
        $('.q-answer[data-answer=' + currentquestion + ']').children('.wrong').show();
        $('.q-answer[data-answer=' + currentquestion + ']').children('.correct').hide();
      }

      //show next
      $('.q-controls').children('.q-next').show();
    });

    $('.q-next').on('click', function () {
      qnextbutton();
      $('.q-wrapper[data-question="' + currentquestion + '"] input[type="radio"]').each(function () {
        //show next button is question has already been answered
        if ($(this).prop('checked')) {
          $('.q-next').show();
        }
      });
      $(this).removeClass('extramargin');
    });

    $('.q-prev').on('click ', function () {
      qprevbutton();
      //hide prev button if on q1 
      if (currentquestion === 1) {
        $(this).hide();
      }
    });

    $('.q-restart').on('click', function () {
      qrestartbutton();
    });


    ///////////
    //functions
    ///////////

    function qnextbutton() {
      answerdatacheck = $('.q-wrapper.current input:checked').data('check');

      //update user score
      userscorecounter.push(answerdatacheck);



      //hide current question and answer
      $('.q-wrapper[data-question="' + currentquestion + '"]').addClass('answered');
      $('.q-wrapper[data-question="' + currentquestion + '"]').hide().removeClass('current');
      $('.q-answer').data('answer', currentquestion).hide();
      $('.q-answer div').removeClass('animate');

      //update progress bar
      currentpercentage = percentperqnumber * currentquestion,
          numberanswered = $('.q-wrapper.answered').length;
      progressbarstate = percentperqnumber * numberanswered;

      //run progress bar update (if it's not already set the users progress)
      if (progressbarstate <= currentpercentage) {
        $('.progress-bar').css('width', currentpercentage + '%').attr('aria-valuenow', currentpercentage);
      }

      //update currentquestion variable
      currentquestion = currentquestion + 1;

      //update question number count
      $('.q-number .currentq').html(currentquestion);

      //show next question
      $('.q-wrapper[data-question="' + currentquestion + '"]').show().addClass('current');

      //has the user already answered this (if true show answer description)
      if ($('.q-wrapper.current[data-question="' + currentquestion + '"]').hasClass('answered')) {
        $('.q-answer[data-answer="' + currentquestion + '"]').show();
      }

      if (currentquestion > 1) {
        //show previous question button
        $('.q-prev').show();
      }

      if (currentquestion > totalqnumber) {
        //show end of quiz states
        $('.progress-bar').css('width', '100%').attr('aria-valuenow', '100');
        $('.q-progress').addClass('hideonmobile');
        $('.q-number, .q-next').hide();
        $('.q-results, .q-restart').show();
        finalscore = countInArray(userscorecounter, 1);
        $('.q-results .score').html(finalscore);
      }

      //hide next button again (in prep for next question)
      $('.q-next').hide();

      wordingonnextbutton();

      smoothscroll(400);
    }

    function qprevbutton() {
      //delete last answer from score array
      userscorecounter.splice(-1, 1);

      //add answered class to current question to ensure answer is stored on return
      $('.q-wrapper[data-question="' + currentquestion + '"] input[type="radio"]').each(function () {
        if ($(this).prop('checked')) {
          $('.q-wrapper[data-question="' + currentquestion + '"]').addClass('answered');
        }
      });



      //update currentquestion variable
      currentquestion = currentquestion - 1;



      //hide current question

      $('.q-wrapper.current').hide().removeClass('current').next('.q-answer').hide();
      $('.q-results, .q-restart').hide();

      //show previous question
      $('.q-wrapper[data-question=' + currentquestion + ']').addClass('current').show().next('.q-answer').show();
      $('.q-number, .q-next').show();

      //update question number count
      $('.q-number .currentq').html(currentquestion);

      $('.q-progress').removeClass('hideonmobile');

      //add extra margin to next button if user goes back to question 1
      if (currentquestion === 1) {
        $('.q-next').addClass('extramargin');
      }

      wordingonnextbutton();

      smoothscroll(400);
    }

    function qrestartbutton() {
      //wipe score
      userscorecounter = ['Quiz Answers:'];

      //uncheck all answers
      $('input[type="radio"]').prop("checked", false);

      //reset views
      $('.q-wrapper').removeClass('answered')
      $('.q-results .score').html('0');
      $('.q-wrapper, .q-answer, .q-answer .correct, .q-answer .wrong, .q-prev, .q-next, .q-results, .q-restart').hide();
      $('.q-wrapper[data-question="1"]').show().addClass('current');

      currentquestion = $('.q-wrapper.current').data('question'),
          currentradio = $('.q-wrapper.current[data-question="' + currentquestion + '"] input:radio'),
          percentperqnumber = 100 / totalqnumber,
          answerdatacheck = 0,
          numberanswered = 0,
          currentpercentage = 0,
          progressbarstate = 0,
          finalscore = 0;

      $('.q-number .currentq').html(currentquestion);
      $('.q-number .total, .q-results .total').html(totalqnumber);
      $('.q-number').show();
      $('.progress-bar').css('width', '0%').attr('aria-valuenow', '0');
      $('.q-progress').removeClass('hideonmobile');
      $('.q-next').addClass('extramargin');

      wordingonnextbutton();

      smoothscroll(400);
    }

    //count right answers and call this in the final results
    function countInArray(array, what) {
      var count = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i] === what) {
          count++;
        }
      }
      return count;
    }
    //smoothscroll to top ogf question when quiz nav buttons are pressed
    function smoothscroll(timing) {

      if ($(window).width() <= 767.98) {
        var headerHeight = 80;
      } else if ($(window).width() <= 991.98) {
        var headerHeight = 110;
      } else {
        var headerHeight = 90;
      }

      $('html, body').stop().animate({
        'scrollTop': $('#topofquiz').offset().top - headerHeight
      }, timing, 'swing');
    }
    //check if the question is the last and if true change text on next button
    function wordingonnextbutton() {
      //check if the question is the last and if true change text on next button
      if (currentquestion >= totalqnumber) {
        $('.q-next').html('See results');
      } else {
        $('.q-next').html('Next question');
      }
    }


    ///////////////
    //accessibility
    ///////////////
    $('.q-next, .q-prev, .q-restart').on('focusin', function () {

      var navidname = $(this).attr('id');

      window.onkeydown = function (event) {
        //spacebar functionality
        if (event.keyCode === 32 || event.keyCode === 13) {
          event.preventDefault();

          if (navidname === 'q-next') {
            qnextbutton();
            $('.q-wrapper[data-question="' + currentquestion + '"] input[type="radio"]').each(function () {
              //show next button is question has already been answered
              if ($(this).prop('checked')) {
                $('.q-next').show();
              }
            });
            $(this).removeClass('extramargin');
          }
          if (navidname === 'q-prev') {
            qprevbutton();
            //hide prev button if on q1 
            if (currentquestion === 1) {
              $('.q-prev').hide();
            }
          }
          if (navidname === 'q-restart') {
            qrestartbutton();
          }
        }

        //return focus to next question on keyboard nav event
        if (event.keyCode === 32 || event.keyCode === 13) {
          if (navidname === 'q-next' || navidname === 'q-prev' || navidname === 'q-restart') {
            $('.q-wrapper.current label:first-of-type input[type="radio"]').focus();
          }
          if (navidname === 'q-next' && currentquestion > totalqnumber) {
            $('.q-restart').focus();
          }
        }
      };
    });

    $('.q-answer a, .q-results a').on('focusin', function () {
      var currenthref = $(this).attr('href');

      if (typeof currenthref !== typeof undefined && currenthref !== false) {
        var thisurl = $(this).attr('href');
      } else {
        var thisurl = '';
      }

      window.onkeydown = function (event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          event.preventDefault();
          if (thisurl !== null && thisurl !== '') {
            window.open('' + thisurl + '', '_blank');
          }
        }
      }

    });



  }
}(jQuery));